import { c as _c } from "react/compiler-runtime";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import ParticipationDropVoteDetailsTrigger from "@/components/waves/drops/participation/ratings/ParticipationDropVoteDetailsTrigger";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import WaveWinnersDropHeaderVoter from "./WaveWinnersDropHeaderVoter";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
interface WaveWinnersDropHeaderVotersProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropHeaderVoters(t0) {
  const $ = _c(16);
  const {
    winner
  } = t0;
  const userVote = winner.drop.context_profile_context?.rating ?? 0;
  const hasUserVoted = userVote !== 0;
  const isNegativeVote = userVote < 0;
  const userVoteClass = isNegativeVote ? "tw-text-rose-400" : "tw-text-iron-50";
  const hasTopRaters = winner.drop.top_raters.length > 0;
  let t1;
  if ($[0] !== hasTopRaters || $[1] !== winner) {
    t1 = hasTopRaters && <div className="tw-flex tw-items-center -tw-space-x-2">{winner.drop.top_raters.map((voter, index) => <WaveWinnersDropHeaderVoter voter={voter} winner={winner} index={index} key={voter.profile.handle} />)}</div>;
    $[0] = hasTopRaters;
    $[1] = winner;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== winner.drop) {
    t2 = <ParticipationDropVoteDetailsTrigger drop={winner.drop} />;
    $[3] = winner.drop;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-text-sm tw-leading-5">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== hasUserVoted || $[9] !== userVote || $[10] !== userVoteClass || $[11] !== winner.drop.wave) {
    t4 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-leading-5"><span className="tw-whitespace-nowrap"><span className="tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:{" "}</span><span className={`tw-font-medium ${userVoteClass}`}>{formatNumberWithCommas(userVote)}{" "}{WAVE_VOTING_LABELS[winner.drop.wave.voting_credit_type]}</span></span></div>;
    $[8] = hasUserVoted;
    $[9] = userVote;
    $[10] = userVoteClass;
    $[11] = winner.drop.wave;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-4 tw-gap-y-2">{t3}{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}